/**
 * @generated SignedSource<<af7a25d0ef901f0e5d2e7ee23585213e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCardFooterFragment$data = {
  readonly rewards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"RewardFragment">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "EventCardFooterFragment";
};
export type EventCardFooterFragment$key = {
  readonly " $data"?: EventCardFooterFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardFooterFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardFooterFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "RewardConnection",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RewardEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Reward",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RewardFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rewards(first:1)"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "bbf4880e1d34a31511bfb93505d511f6";

export default node;
